/* eslint-disable jsx-a11y/no-static-element-interactions */
import { observer } from 'mobx-react';
import { useStores } from 'hooks/use-stores';
import MenuItem from 'models/MenuItem';
import Recommendation from './Recommendation';
import {
  ItemModalHeading,
  DesktopCartHeading,
  MobileCartHeading,
  RecommendationContainer,
  CarouselWrapper,
  Carousel,
} from './recommendationStyles';

interface CarouselProps {
  recommendedItems: string[];
  fromCart: boolean;
  referringItem?: MenuItem;
}

function RecommendationCarousel({ fromCart, recommendedItems, referringItem }: CarouselProps) {
  const {
    checkoutStore: { selectedCart },
    menuDataStore: { menuItemsById },
    uiState: { isMobile },
  } = useStores();

  const remainingRecs = fromCart
    ? recommendedItems.filter((rec) => selectedCart.items.every((item) => item.menu_item_id !== rec))
    : recommendedItems;

  if (!menuItemsById[recommendedItems[0]] || !remainingRecs.length || !recommendedItems.length) {
    return null;
  }

  // eslint-disable-next-line no-nested-ternary
  const Header = fromCart ? (isMobile ? MobileCartHeading : DesktopCartHeading) : ItemModalHeading;
  const headerTitle = fromCart ? 'Complement your order' : 'Recommended with this item';

  return (
    <>
      <RecommendationContainer>
        <Header>{headerTitle}</Header>
        <CarouselWrapper>
          <Carousel className="carousel" role="list">
            {recommendedItems
              .map((item) => menuItemsById[item])
              .filter(
                (item): item is MenuItem =>
                  Boolean(item) && Boolean(item.menus.length) && remainingRecs.includes(item.menu_item_id)
              )
              .map((item) => (
                <Recommendation
                  fromCart={fromCart}
                  referringItem={referringItem}
                  item={item}
                  menuId={item.menus[0].id}
                  key={item.id}
                />
              ))}
          </Carousel>
        </CarouselWrapper>
      </RecommendationContainer>
    </>
  );
}

export default observer(RecommendationCarousel);
